import { debounce } from 'lodash';
import Swiper, { Pagination } from 'swiper';
import Marquee from '@/modules/Marquee/Marquee.js';

class PartnersMix {
  constructor(rootElement) {
    this.rootElement = rootElement;

    this.marquee = null;
    this.swiper = null;

    this.config = {
      marqueePoint: 768,
      sliderPoint: 767,
    };

    this.findElements();
    this.init();
    this.attachEvents();
  }

  findElements() {
    this.slider = this.rootElement.querySelector('[data-entity="slider"]');
    this.pagination = this.rootElement.querySelector('[data-entity="pagination"]');
    this.marqueeElement = this.rootElement.querySelector('[data-entity="marquee"]');
  }

  init() {
    if (window.innerWidth >= this.config.marqueePoint) {
      this.initMarquee();
    }

    if (window.innerWidth <= this.config.sliderPoint) {
      this.initSlider();
    }
  }

  initSlider() {
    this.swiper = new Swiper(this.slider, {
      modules: [Pagination],

      enabled: true,
      slidesPerView: 1,
      spaceBetween: 0,

      pagination: {
        el: this.pagination,
        type: 'bullets',
        dynamicBullets: true,
        dynamicMainBullets: 4,
      },
    });
  }

  initMarquee() {
    this.marquee = new Marquee(this.marqueeElement);
  }

  attachEvents() {
    const debouncedHandler = debounce(this.windowResizeHandler.bind(this), 400);
    window.addEventListener('resize', debouncedHandler);
  }

  windowResizeHandler() {
    if (!this.marquee && window.innerWidth >= this.config.marqueePoint) {
      this.initMarquee();
    }

    if (!this.swiper && window.innerWidth <= this.config.sliderPoint) {
      this.initSlider();
    }
  }
}

export default PartnersMix;
